import { Component, OnInit, EventEmitter, ViewChild } from "@angular/core";
import { MappingService } from "src/app/services/mapping.service";
import { MessageService, ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import { Sharedservice } from "./../../shared-components/shared.service";
import { EngagementService } from "src/app/services/engagement.service";

import {
  UploadOutput,
  UploadInput,
  UploadFile,
  humanizeBytes,
  UploaderOptions,
} from "ngx-uploader";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { ScenarioExecutionService } from "../../services/scenarioexecution.service";
import {
  severitymessage,
  LanguageConstants,
  FunctionalityNames,
} from "../../shared-components/constant";
import { mappingselectionModel } from "../../models/mappingselection.model";
import { UserModel } from "../../models/user.model";
import { UserService } from "../../services/user.service";
import {
  MappingByHierarchyModel,
  AccountDescriptonsByMapping,
} from "src/app/models/mappingByHierarchy.model";
import { ErrorPopUpModel } from "../../models/errorpopup.model";
import { WebJobQueueService } from "src/app/services/webjobqueue.service";
import { WebJobQueueModel } from "src/app/models/webJobQueue.model";
import { TabGroupService } from "../../services/tabGroup.service";
import { TabGroupModel } from "../../models/tabGroup.model";
import { AccountDescriptions } from "../../models/accountDescriptions.model";
import { InfraService } from "src/app/services/infra.service";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { forkJoin } from "rxjs";
import { EngagementModel } from "src/app/models/engagement.model";
import { MasterHelpService } from "src/app/services/masterhelp.service";
import { TemplateEnum } from "src/app/enums/regions.enum";
import { AuditingService } from "../../services/auditing.service";
import { AppConfigurationService } from "./../../services/appConfiguration.service";
import { AppConfigurationsModel } from "./../../models/appConfigurations.model";
import { Observable } from "rxjs";

@Component({
  selector: "app-mappingselection",
  templateUrl: "./mappingselection.component.html",
  styleUrls: ["./mappingselection.component.css"],
})
export class MappingselectionComponent implements OnInit {
  engagementId = +this.route.snapshot.paramMap.get("id");
  private configUrl: string;
  private configCoreUrl: string;
  public uploadInput: EventEmitter<UploadInput>;
  sourceFiles: UploadFile[];

  public dragOver: boolean;
  public options: UploaderOptions;
  humanizeBytes: Function;

  mappingSourceId: number;
  downloadfileName: string;
  defaultMapping: string;
  loadspinner = false;
  isEngagementReadOnly: boolean = false;
  show = false;
  files: mappingselectionModel[] = [];
  selectedBS: mappingselectionModel[] = [];
  selectedPL: mappingselectionModel[] = [];
  selectedMappingPLBS: mappingselectionModel[] = [];
  tempSelectedBS: mappingselectionModel[] = [];
  tempSelectedPL: mappingselectionModel[] = [];
  public accntMapping: mappingselectionModel[];
  public mappingAccntData: any[] = [];
  public rangeValidData: any[] = [];
  public engagement: EngagementModel;
  cols: any[];
  public pagerows: number;
  colshierarchy: any[];
  globalStdMapping: {
    ID: number;
    StandardizedMapping: string;
    MSM_Mapping1: string;
  }[];
  stdMappingBS: {
    ID: number;
    StandardizedMapping: string;
    MSM_Mapping1: string;
  }[];
  stdMappingPL: {
    ID: number;
    StandardizedMapping: string;
    MSM_Mapping1: string;
  }[];
  MappingList: MappingByHierarchyModel[];
  accountDescriptionList: any;
  MappingId = -1;
  selectAllSMId = -1;
  isCheckedSelected: false;
  savedSourceId = 0;
  private loggedInUserId: number;
  account_ID = false;
  Mapping_account_ID = false;
  Auto_account_ID = false;
  Manual_account_ID = false;
  DragAndDrop_account_ID = false;
  index: number;
  standardmapping: string;
  accountLoader = false;
  isResetMappingDisabled = true;
  uploadManualMap = false;
  manualmappingToastKey = "ManualMappingToast";
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  isOverlapping11: boolean;
  invalidStartRange = 0;
  invalidEndRange = 0;
  isOverlapping = false;
  rangeValidatorPLBS = false;
  reg = new RegExp("^[0-9]+$");
  uploadedFileName: string;
  isTempFlatfileUploaded: number;
  private maxsize = environment.maxFileSize * 1024 * 1024;
  webJobQueueId: number;
  isTimeIntervalInProgress = false;
  timeOutHandler: NodeJS.Timer;
  GroupId = 1;
  public tabGroups: TabGroupModel[];
  accountDescriptions: AccountDescriptions[];
  availableAccountDescriptions: AccountDescriptions[] = [];
  mappedAccountDescriptions: any[] = [];
  selectedAccountDescription: AccountDescriptions = null;
  selectedMultipleAccountDescriptions: AccountDescriptions[] = [];
  disableTabGroup = false;
  private accountIdSortOrder = false;
  mappingType: string;
  isOption = true;
  isDefault = false;
  confirmdisplay = false;
  mappingList = [];
  groupAccountDescriptionEnable = true;
  mappingLevel = null;
  dragDropValue = "";
  groupId: number;
  deleteMappedAccounts = false;
  sourceId = 3;
  @ViewChild("tabView", { static: true }) tabView: any;
  langCode: string;
  currLangTranslation: any;
  db_langCode: string;
  db_currLangTranslation: any;
  nextStep: any;
  previousStep: any;
  isAccDescDragDropMoved = false;
  normalConfirmKeyReset = "normalReset";
  EXCEL_CONTENT_TYPE: string =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

  public isCustomizedEngagement: boolean = false;
  constructor(
    private infraService: InfraService,
    private mappingService: MappingService,
    private http: HttpClient,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private appConfigService: AppConfigurationService,
    private router: Router,
    private sharedService: Sharedservice,
    private engagementService: EngagementService,
    private scenarioExecutionService: ScenarioExecutionService,
    private masterHelpService: MasterHelpService,
    private userService: UserService,
    private confirmationService: ConfirmationService,
    private webJobQueueService: WebJobQueueService,
    private tabGroupService: TabGroupService,
    private translateService: TranslateService,
    private auditingService: AuditingService
  ) {
    this.loggedInUserId = +localStorage.getItem("loggedInUserId");
    this.isEngagementReadOnly =
      this.appConfigService.GetConfigValueByKey("IsProjectsReadOnly");
    this.infraService.infraDetails$.subscribe((data) => {
      this.configUrl = data.WebEndPoint1 + "mapping/" + this.engagementId;
      this.configCoreUrl =
        data.WebEndPoint2 + "mappingselection/addmappingfiletoqueue/";
      this.isTempFlatfileUploaded =
        this.sharedService.getLocalStorageValueByName(
          "isTempFlatfileUploaded" + this.engagementId + data.InfraId
        );
    });

    this.options = {
      concurrency: 1,
      allowedContentTypes: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel.sheet.macroEnabled.12",
      ],
    };

    this.sourceFiles = []; // local uploading sourceFiles array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
  }

  ngOnInit() {
    this.selectedMappingPLBS = [];
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation =
      this.translateService.translations[this.langCode];

    this.nextStep = this.currLangTranslation.actionButtons.nextStep;
    this.previousStep = this.currLangTranslation.actionButtons.previousStep;

    this.translateService.onLangChange.subscribe(
      (langEvent: LangChangeEvent) => {
        this.currLangTranslation = langEvent.translations;
        this.previousStep = this.currLangTranslation.actionButtons.previousStep;
        this.nextStep = this.currLangTranslation.actionButtons.nextStep;
      }
    );

    this.cols = [
      { field: "SMId", header: "SMId", visible: false, transText: "SMId" },
      {
        field: "StandardizedMapping",
        header: "Standardized Mapping",
        visible: true,
        transText: "standardizedMapping",
      },
      {
        field: "StartRange",
        header: "Start Range",
        visible: true,
        transText: "startRange",
      },
      {
        field: "EndRange",
        header: "End Range",
        visible: true,
        transText: "endRange",
      },
      {
        field: "isNotValid",
        header: "isNotValid",
        visible: false,
        transText: "isNotValid",
      },
      {
        field: "AddRange",
        header: "Add Range",
        visible: true,
        transText: "addRange",
      },
    ];

    this.pagerows = environment.pageRows;
    this.engagementService
      .getEngagement(this.engagementId)
      .subscribe((data) => {
        this.isCustomizedEngagement = data.IsCustomizedEngagement;        
        if (this.db_langCode === this.langCode) {
          this.db_currLangTranslation = JSON.parse(
            JSON.stringify(this.currLangTranslation)
          );
        } else {
          this.http
            .get(`../assets/i18n/${data.LanguageCode}.json`)
            .subscribe((i18n) => {
              this.db_currLangTranslation = i18n;
            });
        }
        this.getPageData();
      });

    if (this.isTempFlatfileUploaded === 1) {
      if (
        this.engagementService.engModel.IsPnP &&
        this.engagementService.engModel.TemplateId != 3 && this.engagementService.engModel.AccCalendarId  === 1
      )
        this.sharedService.setactiveindex(2);
      else this.sharedService.setactiveindex(1);
    } else {
      this.sharedService.setactiveindex(4);
    }

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData.Id !== undefined) {
        this.loggedInUserId = userData.Id;
      }
    });
  }

  getPageData() {
    this.getAccountId();
    this.checkAccountIdCountGreaterThan10Digit();
    this.loadspinner = true;
    this.tabGroupService.getAllTabGroupsByEngId(this.engagementId).subscribe(
      (tabGroupData: TabGroupModel[]) => {
        const lookup = {};
        const result = [];
        for (let item, i = 0; (item = tabGroupData[i++]); ) {
          const _group = item.group;
          if (!(_group in lookup)) {
            lookup[_group] = 1;
            const _mappingTypeBS = tabGroupData.filter(
              (m1) => m1.group === _group && m1.mappingType === "BS"
            );
            const _mappingTypesPL = tabGroupData.filter(
              (m1) => m1.group === _group && m1.mappingType === "PL"
            );
            const _mappingTypesBoth = tabGroupData.filter(
              (m1) => m1.group === _group && m1.mappingType === "Both"
            );

            if (_mappingTypeBS.length > 0 && _mappingTypesPL.length > 0) {
              this.mappingType = "Both";
            } else if (_mappingTypesBoth.length > 0) {
              this.mappingType = "Both";
            } else {
              if (_mappingTypeBS.length > 0) {
                this.mappingType = "BS";
              }
              if (_mappingTypesPL.length > 0) {
                this.mappingType = "PL";
              }
            }
            result.push(item);
          }
        }
        this.tabGroups = result;

        if (this.tabGroups.length > 0) {
          this.disableTabGroup = false;
          this.groupId = this.tabGroups[0].id;
          this.getAccountDescription(this.tabGroups[0].id);
        } else {
          this.GroupId = -1;
          this.getAccountDescription(-1);
        }
      },
      (err) => {
        this.loadspinner = false;
        this.messageService.add({
          key: severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
    this.getMasterStandardizedMapping();
  }

  getMasterStandardizedMapping() {
    this.mappingService
      .getMasterStandardizedMapping(this.engagementId)
      .subscribe(
        (response: any) => {
          this.globalStdMapping = <
            { ID: number; StandardizedMapping: string; MSM_Mapping1: string }[]
          >response;
          this.stdMappingBS = this.globalStdMapping.filter(
            (m) => m.MSM_Mapping1 === "BS"
          );
          this.stdMappingPL = this.globalStdMapping.filter(
            (m) => m.MSM_Mapping1 === "PL"
          );

          this.mappingService.getMappingsourceId(this.engagementId).subscribe(
            (resp: any) => {
              this.getMappingAccount();
              if (
                resp.MappingSourceId != null &&
                resp.MappingSourceId != "" &&
                resp.MappingSourceId != undefined &&
                resp.MappingSourceId != 0
              ) {
                this.savedSourceId = resp.MappingSourceId;
                this.uploadedFileName = resp.FileName;
                this.isResetMappingDisabled = false;
              }
              if (this.savedSourceId === 0) {
                this.index = 0;
                this.Auto_account_ID = false;
                this.Mapping_account_ID = false;
                this.Manual_account_ID = false;
                this.DragAndDrop_account_ID = false;
                this.mappingSourceId = 3;
                this.defaultMapping = "Automated Mapping";
                // removing disabled class from p-tab view elements when user does reset mapping
                if (
                  this.tabView.el.nativeElement.querySelectorAll(".p-disabled")
                    .length > 0
                ) {
                  this.tabView.el.nativeElement
                    .querySelectorAll(".p-disabled")
                    .forEach((val) => {
                      if (
                        val.innerText === "Mapping by account ID" &&
                        this.account_ID
                      ) {
                        return;
                      } else {
                        val.classList.remove("p-disabled");
                      }
                    });
                }
              } else if (this.savedSourceId === 3) {
                this.index = 0;
                this.mappingSourceId = 3;
                this.defaultMapping = "Automated Mapping";
                this.account_ID = true;
                this.Mapping_account_ID = true;
                this.Manual_account_ID = true;
                this.DragAndDrop_account_ID = true;
              } else if (this.savedSourceId === 5) {
                this.index = 1;
                this.mappingSourceId = 5;
                this.sourceId = 5;
                this.account_ID = true;
                this.Auto_account_ID = true;
                this.Mapping_account_ID = true;
                this.Manual_account_ID = true;
                this.defaultMapping = "Drag and Drop";
              } else if (this.savedSourceId === 1) {
                this.index = 2;
                this.mappingSourceId = 1;
                this.defaultMapping = "Mapping By Account Id";
                this.Auto_account_ID = true;
                this.Mapping_account_ID = true;
                this.Manual_account_ID = true;
                this.DragAndDrop_account_ID = true;
              } else if (this.savedSourceId === 4) {
                this.index = 3;
                this.mappingSourceId = 4;
                this.sourceId = 4;
                this.defaultMapping = "Manual Mapping";
                this.account_ID = true;
                this.Mapping_account_ID = true;
                this.Auto_account_ID = true;
                this.DragAndDrop_account_ID = true;
              }

              if (this.isAccDescDragDropMoved === true) {
                this.index = 1;
                this.mappingSourceId = 5;
                this.isAccDescDragDropMoved = false;
              }
            },
            (err) => {
              this.loadspinner = false;
              this.messageService.add({
                key: severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong,
                sticky: true,
                closable: true,
              });
            }
          );
        },
        (err) => {
          this.loadspinner = false;
          this.messageService.add({
            key: severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  getMappingLevelByGroupId(engagementId, groupId) {
    this.mappingService
      .getMappingLevelAccountById(engagementId, groupId)
      .subscribe((response: any) => {
        this.mappingList = response;
      });
  }

  mappingByIdValidation(): boolean {
    let selectedPLBS = this.selectedMappingPLBS;
    selectedPLBS = selectedPLBS.filter((x) => x.StartRange != null);
    const startrangeno = selectedPLBS.filter(
      (x) => x.StartRange || x.StartRange === 0
    );
    const endRangeno = selectedPLBS.filter(
      (x) => x.EndRange || x.EndRange === 0 || x.EndRange == null
    );
    const allStartRangeValue = startrangeno.map((item) => item.StartRange);
    const allEndRangeValue = endRangeno.map((item) => item.EndRange);
    this.isOverlapping = false;
    this.isOverlapping11 = this.isOverlapping;
    let overlappingStartRange = 0;
    let overlappingEndRange = 0;

    for (let i = 0; i < selectedPLBS.length; i++) {
      this.selectedMappingPLBS.find(
        (x) => x.StandardizedMapping === selectedPLBS[i].StandardizedMapping
      ).isNotValid = false;
      for (let j = 0; j < i; j++) {
        if (
          allStartRangeValue[i] === allStartRangeValue[j] ||
          allStartRangeValue[i] === allEndRangeValue[j]
        ) {
          this.invalidStartRange = allStartRangeValue[i];
          const isBackOverLapping = this.addBackValidation(
            allStartRangeValue,
            allEndRangeValue,
            i,
            j
          );
          if (!isBackOverLapping) {
          } else {
            this.selectedMappingPLBS.find(
              (x) =>
                x.StandardizedMapping === selectedPLBS[i].StandardizedMapping
            ).isNotValid = true;
            this.selectedMappingPLBS.find(
              (x) =>
                x.StandardizedMapping === selectedPLBS[j].StandardizedMapping
            ).isNotValid = true;
            this.isOverlapping = true;
            overlappingStartRange = allStartRangeValue[i];
            overlappingEndRange = allEndRangeValue[i];
          }
        } else if (
          (allEndRangeValue[i] === allEndRangeValue[j] ||
            allEndRangeValue[i] === allStartRangeValue[j]) &&
          this.isOverlapping === false
        ) {
          this.invalidEndRange = allEndRangeValue[i];
          let isBackOverLapping = false;
          if (allEndRangeValue[i] != null && allEndRangeValue[j] != null) {
            isBackOverLapping = this.addBackValidation(
              allStartRangeValue,
              allEndRangeValue,
              i,
              j
            );
          }
          if (!isBackOverLapping) {
          } else {
            this.selectedMappingPLBS.find(
              (x) =>
                x.StandardizedMapping === selectedPLBS[i].StandardizedMapping
            ).isNotValid = true;
            this.selectedMappingPLBS.find(
              (x) =>
                x.StandardizedMapping === selectedPLBS[j].StandardizedMapping
            ).isNotValid = true;
            this.isOverlapping = true;
            overlappingStartRange = allStartRangeValue[i];
            overlappingEndRange = allEndRangeValue[i];
          }
        } else if (
          allStartRangeValue[i] <= allStartRangeValue[j] &&
          allEndRangeValue[i] >= allStartRangeValue[j]
        ) {
          this.invalidStartRange = allStartRangeValue[i];
          this.invalidEndRange = allEndRangeValue[i];
          const isBackOverLapping = this.addBackValidation(
            allStartRangeValue,
            allEndRangeValue,
            i,
            j
          );
          if (!isBackOverLapping) {
          } else {
            this.selectedMappingPLBS.find(
              (x) =>
                x.StandardizedMapping === selectedPLBS[i].StandardizedMapping
            ).isNotValid = true;
            this.selectedMappingPLBS.find(
              (x) =>
                x.StandardizedMapping === selectedPLBS[j].StandardizedMapping
            ).isNotValid = true;
            this.isOverlapping = true;
            overlappingStartRange = allStartRangeValue[i];
            overlappingEndRange = allEndRangeValue[i];
          }
        } else if (
          allStartRangeValue[i] >= allStartRangeValue[j] &&
          allStartRangeValue[i] <= allEndRangeValue[j]
        ) {
          this.invalidStartRange = allStartRangeValue[i];
          this.invalidEndRange = allEndRangeValue[i];
          const isBackOverLapping = this.addBackValidation(
            allStartRangeValue,
            allEndRangeValue,
            i,
            j
          );
          if (!isBackOverLapping) {
          } else {
            this.selectedMappingPLBS.find(
              (x) =>
                x.StandardizedMapping === selectedPLBS[i].StandardizedMapping
            ).isNotValid = true;
            this.selectedMappingPLBS.find(
              (x) =>
                x.StandardizedMapping === selectedPLBS[j].StandardizedMapping
            ).isNotValid = true;
            this.isOverlapping = true;
            if (allEndRangeValue[j] < allEndRangeValue[i]) {
              overlappingEndRange = allEndRangeValue[i];
            } else {
              overlappingEndRange = allEndRangeValue[j];
            }
            overlappingStartRange = allStartRangeValue[j];
          }
        }
      }

      if (
        selectedPLBS[i].StartRange > selectedPLBS[i].EndRange &&
        selectedPLBS[i].EndRange != null
      ) {
        this.selectedMappingPLBS.forEach((x) => (x.isNotValid = false));
        this.selectedMappingPLBS.find(
          (x) =>
            x.StartRange === selectedPLBS[i].StartRange &&
            x.EndRange === selectedPLBS[i].EndRange
        ).isNotValid = true;
        this.rangeValidatorPLBS = true;
        break;
      }
    }

    if (this.rangeValidatorPLBS === false) {
      if (this.isOverlapping) {
        this.loadspinner = false;
        if (overlappingStartRange < overlappingEndRange) {
          const selectedOverLappingPLBS = this.selectedMappingPLBS
            .filter(
              (x) =>
                x.StartRange >= overlappingStartRange &&
                x.EndRange <= overlappingEndRange
            )
            .filter((x) => x.StartRange);

          for (let i = 0; i < this.selectedMappingPLBS.length; i++) {
            if (
              this.selectedMappingPLBS[i].EndRange == null &&
              this.selectedMappingPLBS[i].StartRange != null
            ) {
              if (
                overlappingEndRange < this.selectedMappingPLBS[i].StartRange
              ) {
                this.selectedMappingPLBS[i].isNotValid = false;
              }
            }
          }
        }
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.mappingselectionComponentmessage.DetailMessage.overlappingRange;
      }
    } else {
      this.loadspinner = false;
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage =
        this.currLangTranslation.mappingselectionComponentmessage.Summary.rangevalidation;
    }
    this.isOverlapping11 = this.isOverlapping;
    return this.isOverlapping;
  }

  addBackValidation(
    startRangeValue: number[],
    endRangeValue: number[],
    indexValueI: number,
    indexValueJ: number
  ): boolean {
    let isAddbackOverlapping = false;
    const i = 0;
    const j = 0;
    const selectedMappingValue = this.selectedMappingPLBS.filter(
      (x) => x.StartRange != null
    );
    const selectedRangeAddBack1 = this.selectedMappingPLBS.filter(
      (x) => x.SMId === selectedMappingValue[indexValueI].SMId
    );
    const selectedRangeAddBack2 = this.selectedMappingPLBS.filter(
      (x) => x.SMId === selectedMappingValue[indexValueJ].SMId
    );

    if (
      selectedRangeAddBack1[i].IsAddBack === true &&
      selectedRangeAddBack2[j].IsAddBack === true
    ) {
      isAddbackOverlapping = true;
    } else if (
      selectedRangeAddBack1[i].IsAddBack === true &&
      selectedRangeAddBack2[j].IsAddBack === false
    ) {
      isAddbackOverlapping = false;
    } else if (
      selectedRangeAddBack1[i].IsAddBack === false &&
      selectedRangeAddBack2[j].IsAddBack === true
    ) {
      isAddbackOverlapping = false;
    } else {
      isAddbackOverlapping = true;
    }
    return isAddbackOverlapping;
  }
  // ----- Highlight -- Invalid PL/BS
  // ------------------------- Overlappings issue end ---------------------------

  add(event: any, rowIndex: any, startRange: any, endRange: any) {
    if (!this.isEngagementReadOnly) {
      const filterArr = this.selectedMappingPLBS.filter(
        (w) => w.StandardizedMapping === event
      );
      const isBack = filterArr[0].IsAddBack;
      const eventlength = this.selectedMappingPLBS.filter(
        (x) => x.SMId === filterArr[0].SMId
      ).length;
      const startrangeno = this.selectedMappingPLBS.filter((x) => x.StartRange);
      const endrangeno = this.selectedMappingPLBS.filter((x) => x.EndRange);
      const lastindex = rowIndex + eventlength;
      const resultstart = startrangeno.map((item) => item.StartRange);
      const endResult = endrangeno.map((item) => item.EndRange);
      let rangeValidator: boolean;
      let nullValidator: boolean;
      let zeroValidator: boolean;
      let startOrEndRangeMissingValidator: boolean;
      const lastStartRange: any = resultstart[resultstart.length - 1];
      const lastEndRange: any = endResult[endResult.length - 1];
      const startRangeinputData = this.selectedMappingPLBS.filter(
        (w) => w.StartRange != null
      );
      const endRangeinputData = this.selectedMappingPLBS.filter(
        (w) => w.EndRange != null
      );
      let negativeValidator: boolean;
      negativeValidator = false;

      this.selectedMappingPLBS.forEach((x) => (x.isNotValid = false));
      let someCheck = false;
      for (let i = 0; i < resultstart.length; i++) {
        if (resultstart[i] < 0) {
          negativeValidator = true;
          const value = resultstart[i];
          this.selectedMappingPLBS.find(
            (x) => x.StartRange === value
          ).isNotValid = true;
        }
        if (negativeValidator === false) {
          const value = resultstart[i];
          const count = this.selectedMappingPLBS.filter(
            (i) => i.StartRange === value
          ).length;
          const one = 1;
          if (count > one && someCheck === false) {
            someCheck = true;
          }
        }
      }

      for (let i = 0; i < endResult.length; i++) {
        if (endResult[i] < 0) {
          negativeValidator = true;
          const value = endResult[i];
          this.selectedMappingPLBS.find(
            (x) => x.EndRange === value
          ).isNotValid = true;
        }
      }

      for (let i = 0; i < eventlength; i++) {
        if (resultstart[i] == null) {
          nullValidator = true;

          if (lastStartRange > lastEndRange) {
            rangeValidator = true;
          }
        }
      }

      const index = this.selectedMappingPLBS.findIndex(
        (w) => w.StandardizedMapping === event
      );
      const arr = this.selectedMappingPLBS.filter(
        (x) => x.SMId === filterArr[0].SMId
      );
      let innerIndex = 0;
      let allowBlank = 0;

      for (let i = 0; i < arr.length; i++) {
        const selectedMapping = arr[i];
        if (selectedMapping != null) {
          if (selectedMapping.StartRange == null) {
            if (allowBlank === 0) {
              allowBlank = allowBlank + 1;
            }
            if (allowBlank === 1) {
              {
                nullValidator = true;
                innerIndex = i;
                this.selectedMappingPLBS.forEach((x) => (x.isNotValid = false));
                this.selectedMappingPLBS[index + innerIndex].isNotValid = true;
                break;
              }
            }
          }
        }
      }

      if (nullValidator) {
        if (
          this.selectedMappingPLBS.find((w) => w.StandardizedMapping === event)
            .StartRange == null &&
          this.selectedMappingPLBS.find((w) => w.StandardizedMapping === event)
            .StartRange == null
        ) {
          this.selectedMappingPLBS.forEach((x) => (x.isNotValid = false));
          this.selectedMappingPLBS.find(
            (w) => w.StandardizedMapping === event
          ).isNotValid = true;
        }
      }

      if (startRange == null) {
        nullValidator = true;
      }
      if (startRange === 0 || endRange === 0) {
        zeroValidator = true;
      }

      if (negativeValidator) {
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.mappingselectionComponentmessage.Summary.negativeValidation;
      } else {
        const isOverlapping = this.mappingByIdValidation();
        if (nullValidator) {
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.mappingselectionComponentmessage.Summary.NoBlankRange;
        }

        if (startOrEndRangeMissingValidator) {
          this.selectedMappingPLBS.forEach((x) => (x.isNotValid = false));
          this.selectedMappingPLBS
            .filter((x) => x.StartRange == null && x.EndRange != null)
            .forEach((y) => (y.isNotValid = true));
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.mappingselectionComponentmessage.Summary.StartOrEndRangeMissingValidation; ///MappingselectionComponentmessage.Summary.StartOrEndRangeMissingValidation;
        }
      }

      if (
        !negativeValidator &&
        !rangeValidator &&
        !nullValidator &&
        !startOrEndRangeMissingValidator
      ) {
        if (!this.isOverlapping) {
          if (this.rangeValidatorPLBS === false) {
            this.selectedMappingPLBS.splice(lastindex, 0, {
              StandardizedMapping: null,
              Mapping1: filterArr[0].Mapping1,
              StartRange: null,
              EndRange: null,
              SMId: filterArr[0].SMId,
              isNotValid: filterArr[0].isNotValid,
              IsAddBack: isBack,
            });
          }
        }
      }
      this.rangeValidatorPLBS = false;
    }
  }
  addBSUpdated(event: any, rowIndex: any, startRange: any, endRange: any) {
    if (!this.isEngagementReadOnly) {
      const filterArr = this.selectedMappingPLBS.filter(
        (w) => w.StandardizedMapping === event
      );
      const eventlength = this.selectedMappingPLBS.filter(
        (x) => x.SMId === filterArr[0].SMId
      ).length;
      const startrangeno = this.selectedMappingPLBS.filter((x) => x.StartRange);
      const endrangeno = this.selectedMappingPLBS.filter((x) => x.StartRange);
      const lastindex = rowIndex + eventlength;
      const resultstart = startrangeno.map((item) => item.StartRange);
      const endResult = endrangeno.map((item) => item.EndRange);
      let rangeValidator: boolean;
      let nullValidator: boolean;
      let zeroValidator: boolean;
      let startOrEndRangeMissingValidator: boolean;
      let negativeValidator: boolean;
      const lastStartRange: any = resultstart[resultstart.length - 1];
      const lastEndRange: any = endResult[endResult.length - 1];
      const startRangeinputData = this.selectedMappingPLBS.filter(
        (w) => w.StartRange != null
      );
      const endRangeinputData = this.selectedMappingPLBS.filter(
        (w) => w.EndRange != null
      );

      this.selectedMappingPLBS
        .filter((w) => w.StandardizedMapping !== event)
        .forEach((x) => (x.isNotValid = false));

      for (let i = 0; i < resultstart.length; i++) {
        if (resultstart[i] < 0) {
          negativeValidator = true;
          const value = resultstart[i];
          this.selectedMappingPLBS.find(
            (x) => x.StartRange === value
          ).isNotValid = true;
        }
      }

      for (let i = 0; i < endResult.length; i++) {
        if (endResult[i] < 0) {
          negativeValidator = true;
          const value = endResult[i];
          this.selectedMappingPLBS.find(
            (x) => x.EndRange === value
          ).isNotValid = true;
        }
      }

      for (let i = 0; i < eventlength; i++) {
        if (resultstart[i] == null) {
          nullValidator = true;
          if (lastStartRange > lastEndRange) {
            rangeValidator = true;
          }
        }
      }

      const index = this.selectedMappingPLBS.findIndex(
        (w) => w.StandardizedMapping === event
      );
      const arr = this.selectedMappingPLBS.filter(
        (x) => x.SMId === filterArr[0].SMId
      );
      let innerIndex = 0;
      let allowBlank = 0;

      for (let i = 0; i < arr.length; i++) {
        const selectedMapping = arr[i];
        if (selectedMapping != null) {
          if (
            selectedMapping.StartRange == null &&
            selectedMapping.EndRange == null
          ) {
            if (allowBlank === 0) {
              allowBlank = allowBlank + 1;
            }
            if (allowBlank === 1) {
              {
                nullValidator = true;
                innerIndex = i;
                this.selectedMappingPLBS[index + innerIndex].isNotValid = true;
                break;
              }
            }
          }
        }
      }

      if (negativeValidator) {
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.mappingselectionComponentmessage.Summary.negativeValidation;
      } else {
        const isOverlapping = this.mappingByIdValidation();
        if (nullValidator) {
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.mappingselectionComponentmessage.Summary.NoBlankRange;
        }

        if (startOrEndRangeMissingValidator) {
          this.selectedMappingPLBS.forEach((x) => (x.isNotValid = false));
          this.selectedMappingPLBS
            .filter((x) => x.StartRange == null && x.EndRange != null)
            .forEach((y) => (y.isNotValid = true));
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.mappingselectionComponentmessage.Summary.StartOrEndRangeMissingValidation;
        }

        if (startRange == null) {
          nullValidator = true;
        }
      }

      if (
        !negativeValidator &&
        !rangeValidator &&
        !nullValidator &&
        !startOrEndRangeMissingValidator
      ) {
        if (!this.isOverlapping) {
          if (this.rangeValidatorPLBS === false) {
            this.selectedMappingPLBS.splice(lastindex, 0, {
              StandardizedMapping: null,
              Mapping1: filterArr[0].Mapping1,
              StartRange: null,
              EndRange: null,
              SMId: filterArr[0].SMId,
              isNotValid: filterArr[0].isNotValid,
              IsAddBack: false,
            });
          }
        }
      }
      this.rangeValidatorPLBS = false;
    }
  }
  onUploadOutput(output: UploadOutput, fileInput: any): void {
    if (!this.isEngagementReadOnly) {
      if (output.type === "allAddedToQueue") {
        if (this.sourceFiles.length > 1) {
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.severitymessage.MutiFileUploadError;
          this.sourceFiles = [];
        } else if (this.sourceFiles.length == 1) {
          const event: UploadInput = {
            type: "uploadAll",
            url: `${this.configCoreUrl}${this.engagementId}`,
            method: "POST",
            data: { foo: "bar" },
            headers: {
              Authorization:
                "Bearer " +
                (environment.isBearerAuthorizationEnabled
                  ? localStorage["dbamsaltoken"]
                  : environment.sampleToken),
            },
          };
          this.uploadInput.emit(event);
        }
      } else if (
        output.type === "addedToQueue" &&
        typeof output.file !== "undefined"
      ) {
        if (output.file.size > this.maxsize) {
          fileInput.value = "";
          this.loadspinner = false;
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.severitymessage.MaxsizeError +
            " " +
            output.file.name +
            "  " +
            " of size more than " +
            environment.maxFileSize +
            " MB";
        } else {
          this.sourceFiles.push(output.file);
        }
      } else if (
        output.type === "uploading" &&
        typeof output.file !== "undefined"
      ) {
        // update current data in sourceFiles array for uploading file
        const index = this.sourceFiles.findIndex(
          (file) =>
            typeof output.file !== "undefined" && file.id === output.file.id
        );
        this.sourceFiles[index] = output.file;
        this.uploadManualMap = true;
      } else if (output.type === "done" && typeof output.file !== "undefined") {
        this.loadspinner = true;
        // update current data in sourceFiles array for uploading file
        if (
          output.file &&
          output.file.response &&
          output.file.response.message === "Invalid File Format"
        ) {
          this.loadspinner = false;
          fileInput.value = "";
          this.uploadInput.emit({ type: "remove", id: output.file.id });
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.UploadSourcefilemessage.ErrorMessage.FormateError;
          return;
        }

        const index = this.sourceFiles.findIndex(
          (file) =>
            typeof output.file !== "undefined" && file.id === output.file.id
        );
        const response = this.sourceFiles[index].response;

        if (response === "") {
          // when other excel get uploaded by User
          this.messageService.add({
            key: severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        } else if (this.sourceFiles[0].responseStatus === 400) {
          if (this.sourceFiles[0].response.statusId === 422) {
            // 422 status id means queue is already present for flatfileupload
            this.errorModel.confirmIsDisplay = true;
            this.errorModel.headerTitle =
              this.currLangTranslation.severitymessage.notification;
            this.errorModel.displayMessage =
              this.currLangTranslation.mappingselectionComponentmessage.ErrorMessage.QueueInProgress;
            this.loadspinner = false;
          }
        } else {
          if (response.status === severitymessage.success) {
            this.webJobQueueId = response.id;
            this.checkMappingFileProcessed();
          } else {
            this.loadspinner = false;
            this.uploadManualMap = false;
            this.errorModel.confirmIsDisplay = true;
            this.errorModel.displayMessage = response.message;
          }
        }
        this.sourceFiles = [];
        // Clear file - to upload same file name twice
        fileInput.value = "";
      } else if (
        output.type === "rejected" &&
        typeof output.file !== "undefined"
      ) {
        this.uploadManualMap = false;
        // Replace with Notification service
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.UploadSourcefilemessage.ErrorMessage.FormateError;
        fileInput.value = "";
        this.sourceFiles = [];
      } else if (output.type === "removed") {
        this.uploadManualMap = false;
        this.sourceFiles = this.sourceFiles.filter(
          (file: UploadFile) => file !== output.file
        );
      } else if (output.type === "dragOver") {
        this.uploadManualMap = false;
        this.dragOver = true;
      } else if (output.type === "dragOut") {
        this.uploadManualMap = false;
        this.dragOver = false;
      } else if (output.type === "drop") {
        this.uploadManualMap = false;
        this.dragOver = false;
      }
    }
  }
  //end
  removeFile(id: string): void {
    this.uploadInput.emit({ type: "remove", id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: "removeAll" });
  }

  handleChange(event: any) {
    if (event.index === 0) {
      this.selectedPL = [];
      this.selectedBS = [];
      this.getMappingAccount();
      this.mappingSourceId = 3;
      this.sourceId = 3;
      this.defaultMapping = "Automated Mapping";
      this.isAccDescDragDropMoved = false;
    } else if (event.index === 1) {
      this.mappingSourceId = 5;
      this.sourceId = 5;
      this.defaultMapping = "Drag and Drop";
      if (this.mappingLevel === null) {
        this.getAccountDescription(this.GroupId);
      }
      this.isAccDescDragDropMoved = true;
    } else if (event.index === 2) {
      this.mappingSourceId = 1;
      this.defaultMapping = "Mapping By Account Id";
      this.isAccDescDragDropMoved = false;
    } else if (event.index === 3) {
      this.mappingSourceId = 4;
      this.sourceId = 4;
      this.defaultMapping = "Manual Mapping";
      this.isAccDescDragDropMoved = false;
    }
    this.messageService.clear();
  }

  nextClicked() {
    this.messageService.clear();
    let auditFunctionalityName = "";
    if (!(this.mappingSourceId === 4 && this.uploadManualMap === true)) {
      this.loadspinner = true;
      this.rangeValidatorPLBS = false;
      this.selectedMappingPLBS.forEach((x) => (x.isNotValid = false));

      if (this.mappingSourceId === 1) {
        auditFunctionalityName = FunctionalityNames.MappingByAccountId;
        const bothRangeValid = false;
        let zeroValidator: boolean;
        let startOrEndRangeMissingValidator: boolean;
        let negativeValidator: boolean;
        this.accntMapping = this.selectedMappingPLBS;
        this.mappingAccntData = this.accntMapping.filter(
          (w) => w.StartRange !== undefined || w.EndRange !== undefined
        );
        this.rangeValidData = this.accntMapping
          .filter((x) => x.EndRange != null && x.StartRange != null)
          .filter((w) => w.StartRange > w.EndRange);
        const startRangeinputData = this.accntMapping.filter(
          (w) => w.StartRange != null
        );
        const endRangeinputData = this.accntMapping.filter(
          (w) => w.EndRange != null
        );
        const startRangeinputDataList = this.accntMapping
          .filter((w) => w.EndRange != null)
          .map((x) => x.StartRange);
        const endRangeinputDataList = this.accntMapping
          .filter((w) => w.StartRange != null)
          .map((x) => x.EndRange);
        startOrEndRangeMissingValidator = false;
        negativeValidator = false;

        const startrangeno = this.selectedMappingPLBS.filter(
          (x) => x.StartRange
        );
        const endrangeno = this.selectedMappingPLBS.filter((x) => x.StartRange);
        const resultstart = startrangeno.map((item) => item.StartRange);
        const endResult = endrangeno.map((item) => item.EndRange);

        for (let i = 0; i < resultstart.length; i++) {
          if (resultstart[i] < 0) {
            negativeValidator = true;
            const value = resultstart[i];
            this.selectedMappingPLBS.find(
              (x) => x.StartRange === value
            ).isNotValid = true;
          }
        }

        for (let i = 0; i < endResult.length; i++) {
          if (endResult[i] < 0) {
            negativeValidator = true;
            const value = endResult[i];
            this.selectedMappingPLBS.find(
              (x) => x.EndRange === value
            ).isNotValid = true;
          }
        }

        if (negativeValidator === false) {
          const isOverlapping = this.mappingByIdValidation();
        }

        for (let i = 0; i < startRangeinputDataList.length; i++) {
          if (startRangeinputDataList[i] == null) {
            startOrEndRangeMissingValidator = true;
          }
        }

        if (this.mappingAccntData.length !== 0) {
          if (negativeValidator) {
            this.loadspinner = false;
            this.errorModel.confirmIsDisplay = true;
            this.errorModel.displayMessage =
              this.currLangTranslation.mappingselectionComponentmessage.Summary.negativeValidation;
          } else {
            if (!startOrEndRangeMissingValidator) {
              if (!bothRangeValid) {
                if (this.rangeValidData.length === 0) {
                  if (!this.isOverlapping) {
                    let mappingData;
                    mappingData = {
                      EngagementId: this.engagementId,
                      MappingAccount: this.mappingAccntData,
                    };
                    this.mappingService
                      .updateMappingSource(
                        this.engagementId,
                        this.mappingSourceId
                      )
                      .subscribe(
                        (res) => {
                          this.mappingService
                            .createMappingAccount(mappingData)
                            .subscribe(
                              (response: any) => {
                                if (
                                  response.message === severitymessage.success
                                ) {
                                  this.populateSuggestions();
                                }
                              },
                              (error) => {
                                this.loadspinner = false;
                                this.messageService.add({
                                  key: severitymessage.key,
                                  severity: severitymessage.error,
                                  summary:
                                    this.currLangTranslation.severitymessage
                                      .notification,
                                  detail:
                                    this.currLangTranslation.severitymessage
                                      .Error,
                                  sticky: true,
                                  closable: true,
                                });
                              }
                            );
                        },
                        (err) => {
                          this.loadspinner = false;
                          this.messageService.add({
                            key: severitymessage.key,
                            severity: severitymessage.error,
                            summary:
                              this.currLangTranslation.severitymessage
                                .notification,
                            detail:
                              this.currLangTranslation.severitymessage.Error,
                            sticky: true,
                            closable: true,
                          });
                        }
                      );
                  }
                }
              } else if (bothRangeValid) {
                this.selectedMappingPLBS
                  .filter((x) => x.StartRange == null && x.EndRange != null)
                  .forEach((y) => (y.isNotValid = true));
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage =
                  this.currLangTranslation.mappingselectionComponentmessage.Summary.NoBlankRange;
              }
            } else if (startOrEndRangeMissingValidator) {
              this.loadspinner = false;
              this.selectedMappingPLBS.forEach((x) => (x.isNotValid = false));
              this.selectedMappingPLBS
                .filter((x) => x.StartRange == null && x.EndRange != null)
                .forEach((y) => (y.isNotValid = true));
              this.errorModel.confirmIsDisplay = true;
              this.errorModel.displayMessage =
                this.currLangTranslation.mappingselectionComponentmessage.Summary.StartOrEndRangeMissingValidation; //MappingselectionComponentmessage.Summary.StartOrEndRangeMissingValidation;
            }
          }
        } else {
          this.loadspinner = false;
        }
      } else if (
        this.mappingSourceId === 3 ||
        this.mappingSourceId === 4 ||
        this.mappingSourceId === 5
      ) {
        if (this.mappingSourceId === 3) {
          auditFunctionalityName = FunctionalityNames.AutomatedMapping;
        } else if (this.mappingSourceId === 4) {
          auditFunctionalityName = FunctionalityNames.ManualMapping;
        } else if (this.mappingSourceId === 5) {
          auditFunctionalityName = FunctionalityNames.DragAndDrop;
        }
        this.mappingSourceId = this.sourceId;
        if (!this.isEngagementReadOnly) {
          this.mappingService
            .updateMappingSource(this.engagementId, this.mappingSourceId)
            .subscribe(
              (res) => {
                this.populateSuggestions();
              },
              (err) => {
                this.loadspinner = false;
                this.messageService.add({
                  key: severitymessage.key,
                  severity: severitymessage.error,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail: this.currLangTranslation.severitymessage.Error,
                  sticky: true,
                  closable: true,
                });
              }
            );
        } else {
          this.populateSuggestions();
        }
      }

      this.auditingService
        .addAudit(this.engagementId, auditFunctionalityName)
        .subscribe();
    }
  }

  populateSuggestions() {
    this.scenarioExecutionService
      .generateMappingSuggestion(this.engagementId, this.loggedInUserId)
      .subscribe(
        (resp) => {
          this.loadspinner = false;
          this.router.navigate([
            "/engagement/",
            this.engagementId,
            "remediation",
          ]);
        },
        (err) => {
          this.loadspinner = false;
          this.messageService.add({
            key: severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.Error,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  checkMappingFileProcessed() {
    this.webJobQueueService.getWebJobQueue(this.webJobQueueId).subscribe(
      (resp: WebJobQueueModel) => {
        if (resp) {
          if (!resp.isQueued) {
            this.loadspinner = false;
            this.isTimeIntervalInProgress = false;
            clearInterval(this.timeOutHandler);
            if (resp.isError) {
              if (resp.responseText === "") {
                this.messageService.add({
                  key: severitymessage.key,
                  severity: severitymessage.error,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.severitymessage.somethingwrong,
                  sticky: true,
                  closable: true,
                });
              } else {
                this.loadspinner = false;
                this.uploadManualMap = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = resp.responseText.split("@@");
              }
            } else {
              this.loadspinner = false;
              this.uploadManualMap = false;
              this.uploadedFileName = resp.fileName;
              this.messageService.add({
                key: severitymessage.key,
                severity: severitymessage.success,
                summary: severitymessage.notification,
                detail:
                  this.currLangTranslation.mappingselectionComponentmessage
                    .SuccessMessage.AddFile,
                sticky: true,
                closable: true,
              });
            }
          } else {
            if (!this.isTimeIntervalInProgress) {
              this.timeOutHandler = setInterval(() => {
                this.isTimeIntervalInProgress = true;
                this.loadspinner = true;
                this.checkMappingFileProcessed();
              }, environment.webjobTimer);
            }
          }
        } else {
          if (!this.isTimeIntervalInProgress) {
            this.timeOutHandler = setInterval(() => {
              this.isTimeIntervalInProgress = true;
              this.loadspinner = true;
              this.checkMappingFileProcessed();
            }, environment.webjobTimer);
          }
        }
      },
      (err) => {
        this.loadspinner = false;
        this.isTimeIntervalInProgress = false;
        clearInterval(this.timeOutHandler);
        this.messageService.add({
          key: severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  onDownloadClick(event: any) {
    this.loadspinner = true;
    forkJoin([
      this.engagementService.getEngagement(this.engagementId),
      this.mappingService.getManualMappingTemplate(this.engagementId),
    ]).subscribe((results: any) => {
      this.loadspinner = false;
      const enggModel: EngagementModel = results[0];
      const fileContent = results[1];
      this.downloadfileName = enggModel.EngagementName;
      const today = new Date();
      let todayDateString: any;
      if (fileContent) {
        this.http
          .get(`../assets/i18n/${enggModel.LanguageCode}.json`)
          .subscribe((i18n: any) => {
            if (
              enggModel.TemplateId === 0 ||
              enggModel.TemplateId === TemplateEnum.Americas
            ) {
              todayDateString =
                ("0" + (today.getMonth() + 1)).slice(-2) +
                ("0" + today.getDate()).slice(-2) +
                today.getFullYear();
              this.downloadfileName +=
                `_${i18n.labels.downloadManualMappingSuffixName}_` +
                `${todayDateString}.xlsx`;
            } else {
              todayDateString =
                ("0" + today.getDate()).slice(-2) +
                ("0" + (today.getMonth() + 1)).slice(-2) +
                today.getFullYear();
              this.downloadfileName +=
                `_${i18n.labels.downloadManualMappingSuffixName}_` +
                `${todayDateString}.xlsx`;
            }
            this.masterHelpService.downloadFileByBlob(
              fileContent,
              this.downloadfileName,
              this.EXCEL_CONTENT_TYPE
            );
          });
      } else {
        this.loadspinner = false;
        this.messageService.add({
          key: severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    });
  }

  closeEventworkallocation(event: any) {
    this.confirmdisplay = event;
  }

  previousButton() {
    this.confirmdisplay = false;
    if (this.isTempFlatfileUploaded === 1) {
      this.router.navigate([
        "/engagement/" + this.engagementId + "/uploaddownloadflatfile",
      ]);
    } else {
      this.router.navigate(["/engagement/", this.engagementId, "scenario"]);
    }
  }

  private getMappingAccount(): void {
    let previousstndmapping = "";
    this.mappingService.getMappingAccount(this.engagementId).subscribe(
      (data: mappingselectionModel[]) => {        
        this.selectedMappingPLBS = [];
        this.accntMapping = data;
        if (this.accntMapping) {
          this.selectedBS = [];
          this.selectedPL = [];
          this.accntMapping.forEach((element) => {
            if (
              element.StandardizedMapping === previousstndmapping 
            ) {
              this.selectedMappingPLBS.push({
                StandardizedMapping: null,
                Mapping1: element.Mapping1,
                StartRange: element.StartRange ? element.StartRange : null,
                EndRange: element.EndRange ? element.EndRange : null,
                SMId: element.SMId,
                isNotValid: element.isNotValid,
                IsAddBack: element.IsAddBack,
              });
            } else {
              previousstndmapping = element.StandardizedMapping;
              this.selectedMappingPLBS.push({
                StandardizedMapping: element.StandardizedMapping,
                Mapping1: element.Mapping1,
                StartRange: element.StartRange ? element.StartRange : null,
                EndRange: element.EndRange ? element.EndRange : null,
                SMId: element.SMId,
                isNotValid: element.isNotValid,
                IsAddBack: element.IsAddBack,
              });
            }
          });          
        }
      },
      (err) => {
        this.messageService.add({
          key: severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  private getAccountId(): void {
    this.loadspinner = true;
    this.mappingService.getAccountId(this.engagementId).subscribe(
      (dataAccnt: any) => {
        if (dataAccnt !== null && dataAccnt !== undefined) {
          if (dataAccnt.naturalAccount !== null) {
            this.account_ID = false;
          } else {
            this.account_ID = true;
          }
        } else {
          this.account_ID = true;
        }
        this.loadspinner = false;
      },
      (err) => {
        this.loadspinner = false;
        if (err.status === 400) {
          this.account_ID = true;
        } else {
          this.messageService.add({
            key: severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      }
    );
  }

  private checkAccountIdCountGreaterThan10Digit(): void {
    this.loadspinner = true;
    this.mappingService
      .getAccountIdCountGreaterThan10Digit(this.engagementId)
      .subscribe(
        (data: any) => {
          if (data.naturalAccountNumberCount > 0) {
            this.account_ID = true;
          }
          this.loadspinner = false;
        },
        (err) => {
          this.loadspinner = false;
          this.messageService.add({
            key: severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  selectMappingChange(mappingId: any) {
    this.isAccDescDragDropMoved = true;
    if (mappingId === "-1") {
      this.mappingLevel = null;
      this.groupAccountDescriptionEnable = true;
      this.getAccountDescription(this.groupId);
    } else {
      this.accountLoader = true;
      this.groupAccountDescriptionEnable = false;
      mappingId = mappingId.split(" ").join("");
      this.mappingLevel = mappingId;
      this.mappingService
        .getAccountDescriptionByMappingId(
          this.engagementId,
          this.groupId,
          mappingId
        )
        .subscribe(
          (response: AccountDescriptonsByMapping[]) => {
            this.accountLoader = false;
            const accountDescriptions = response;
            this.accountDescriptionList = accountDescriptions.filter(
              (m) => m.SMID === 0
            );
            this.mappedAccountDescriptions = accountDescriptions.filter(
              (m) => m.SMID !== 0
            );
            if (
              !this.deleteMappedAccounts &&
              this.mappedAccountDescriptions.length > 0
            ) {
              this.getMasterStandardizedMapping();
            }
          },
          (err) => {
            this.accountLoader = false;
            this.accountDescriptionList = [];
            this.mappedAccountDescriptions = [];
            this.messageService.add({
              key: severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        );
    }
  }

  deleteMappingData() {
    if (!this.isResetMappingDisabled) {
      this.confirmationService.confirm({
        key:this.normalConfirmKeyReset,
        message:
          this.currLangTranslation.mappingselectionComponentmessage
            .ConfirmMessage.ConfirmResetProcessing,
        header: this.currLangTranslation.labels.confirmation,
        acceptLabel: this.currLangTranslation.actionButtons.yes,
        rejectLabel: this.currLangTranslation.actionButtons.no,
        accept: () => {
          this.loadspinner = true;
          this.mappingService.deleteProcessingData(this.engagementId).subscribe(
            (response: any) => {
              this.loadspinner = false;
              if (response.status === "success") {
                this.uploadedFileName = null;
                this.messageService.add({
                  key: severitymessage.key,
                  severity: severitymessage.success,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.mappingselectionComponentmessage
                      .SuccessMessage.ResetMapping,
                  sticky: true,
                  closable: true,
                });

                this.isResetMappingDisabled = true;
                this.savedSourceId = 0;
                this.index = 0;
                this.sourceId = 3;
                this.MappingId = -1;
                this.sourceFiles = [];
                this.accountDescriptionList = [];
                this.getPageData();
              } else {
                this.messageService.add({
                  key: severitymessage.key,
                  severity: severitymessage.error,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.severitymessage.somethingwrong,
                  sticky: true,
                  closable: true,
                });
              }
            },
            (error) => {
              this.loadspinner = false;
              this.messageService.add({
                key: severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong,
                sticky: true,
                closable: true,
              });
            }
          );
          this.auditingService
            .addAudit(this.engagementId, FunctionalityNames.ResetMapping)
            .subscribe();
        },
        reject: () => {},
      });
    }
  }

  getAccountDescription(groupId) {
    this.loadspinner = true;
    this.groupId = groupId;
    this.MappingId = -1;
    if (groupId === -2) {
      this.isDefault = true;
    } else {
      this.isDefault = false;
      this.getMappingLevelByGroupId(this.engagementId, groupId);
    }
    this.mappingService
      .getAccountDescriptions(this.engagementId, groupId)
      .subscribe(
        (response: any) => {
          setTimeout(() => {
            this.groupAccountDescriptionEnable = true;
            this.accountDescriptions = response;
            if (this.accountDescriptions.length > 0) {
              this.availableAccountDescriptions =
                this.accountDescriptions.filter((m) => m.SMId === 0);
              this.mappedAccountDescriptions = this.accountDescriptions.filter(
                (m) => m.SMId !== 0
              );
              if (
                this.accountIdSortOrder &&
                this.availableAccountDescriptions.filter(
                  (m) => m.NaturalAccount !== ""
                ).length > 0
              ) {
                return this.availableAccountDescriptions.sort((a, b) => {
                  return b.NaturalAccountNumber - <any>a.NaturalAccountNumber;
                });
              }
              const tabgroup = this.accountDescriptions.filter(
                (m) => m.TabGroupId === 0
              );
              if (tabgroup.length > 0) {
                this.mappingType = "Both";
                this.isOption = false;
                this.isDefault = false;
              }
            } else {
              this.mappingLevel = null;
              this.accountDescriptions = [];
              this.availableAccountDescriptions = [];
            }
            this.loadspinner = false;
          }, 1000);
        },
        (err) => {
          this.loadspinner = false;
          this.messageService.add({
            key: severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  updateStdMappings(accountDescriptions: AccountDescriptions[]) {
    this.messageService.clear();
    this.loadspinner = true;
    this.mappingService
      .updateStdMappings(
        accountDescriptions,
        this.engagementId,
        this.mappingLevel
      )
      .subscribe(
        (response: any) => {
          this.messageService.add({
            key: severitymessage.key,
            severity: severitymessage.success,
            summary: this.currLangTranslation.severitymessage.notification,
            detail:
              this.currLangTranslation.mappingselectionComponentmessage
                .SuccessMessage.UpdateStdMappings,
            sticky: false,
            closable: true,
          });
          this.loadspinner = false;
          this.selectedAccountDescription = null;
          this.selectedMultipleAccountDescriptions = [];
          if (this.mappingLevel === null) {
            this.getAccountDescription(this.GroupId);
            this.getMasterStandardizedMapping();
          } else {
            this.deleteMappedAccounts = false;
            this.selectMappingChange(this.mappingLevel);
          }
        },
        (err) => {
          this.loadspinner = false;
          this.selectedAccountDescription = null;
          this.selectedMultipleAccountDescriptions = [];
          this.messageService.add({
            key: severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  getMappedAccountDescriptionsLength(smId) {
    if (this.mappedAccountDescriptions !== undefined) {
      return this.mappedAccountDescriptions.filter(
        (m) => m.SMID === smId || m.SMId === smId
      ).length;
    } else {
      return 0;
    }
  }

  drop(ev: any, item: any) {
    ev.preventDefault();
    const data = ev.dataTransfer.getData("text");
    this.isAccDescDragDropMoved = true;
    if (ev.target.classList.value !== "draggable-true") {
      const x = document.getElementById("account-description");
      const highlightedItems = x.querySelectorAll(".active-selected");
      if (
        highlightedItems.length > 0 &&
        this.selectedMultipleAccountDescriptions.length > 0
      ) {
        for (
          let i = 0;
          i < this.selectedMultipleAccountDescriptions.length;
          i++
        ) {
          this.selectedMultipleAccountDescriptions[i].SMId = item.SMID;
          this.selectedMultipleAccountDescriptions[i].Mapping1 =
            item.MSM_Mapping1;
          this.selectedMultipleAccountDescriptions[i].IsSuggestionGenerated =
            true;
        }
        this.updateStdMappings(this.selectedMultipleAccountDescriptions);
      } else {
        this.selectedAccountDescription.SMId = item.SMID;
        this.selectedAccountDescription.Mapping1 = item.MSM_Mapping1;
        this.selectedAccountDescription.IsSuggestionGenerated = true;
        const accountDescriptions: AccountDescriptions[] = [];
        accountDescriptions.push(this.selectedAccountDescription);
        this.updateStdMappings(accountDescriptions);
      }
    }

    const group = ev.target.closest(".pl-group-inner-cntr");
    if (group.querySelector(".active") != null) {
      group.querySelector(".active").classList.remove("active");
      const panel = group.querySelector(".hide");
      if (panel) {
        panel.classList.remove("hide");
        panel.classList.add("max-height-inherit");
      }
    }
  }

  allowDrop(ev: any) {
    if (!this.isEngagementReadOnly) {
      ev.preventDefault();
    }
  }
  drag(ev: any, item: any, value: any) {
    this.dragDropValue = value;
    if (value === "accountDrag") {
      this.selectedAccountDescription = item;
    } else {
      item["Id"] = 0;
      item["TabGroupId"] = this.groupId;
      item["NaturalAccount"] = "0";
      item["NaturalAccountNumber"] = 0;
      item["SMId"] = 0;
      if ("SMID" in item) {
        delete item.SMID;
      }
      this.selectedAccountDescription = item;
    }

    ev.dataTransfer.setData("text", ev.target.id);
  }

  onClick(e: any, item: any, mappingLevel: any) {
    if (!this.isEngagementReadOnly) {
      this.deleteMappedAccounts = true;
      const parentPara = e.target.parentNode;
      const parentParaId = parentPara.id;
      const accountDescCntr = document.getElementById("" + parentParaId + "Id");

      // Removes standardized mapping from Database.
      if (mappingLevel !== null) {
        if ("SMID" in item) {
          delete item.SMID;
        }
        item["Id"] = 0;
        item["TabGroupId"] = this.groupId;
        item["NaturalAccount"] = "0";
        item["NaturalAccountNumber"] = 0;
        this.selectedAccountDescription = item;
      } else {
        this.selectedAccountDescription = item;
      }

      this.selectedAccountDescription.SMId = null;
      this.selectedAccountDescription.Mapping1 = null;
      this.selectedAccountDescription.IsSuggestionGenerated = false;
      const accountDescriptions: AccountDescriptions[] = [];
      accountDescriptions.push(this.selectedAccountDescription);
      this.updateStdMappings(accountDescriptions);
    }
  }
  // when we select mapping2 and other mappings we need to send below keys to updatemappings of request parameters
  storeItemKeys(item: any) {
    item["Id"] = 0;
    item["TabGroupId"] = this.groupId;
    item["NaturalAccount"] = "0";
    item["NaturalAccountNumber"] = 0;
    item["SMId"] = 0;
    if ("SMID" in item) {
      delete item.SMID;
    }
  }

  draggableSelect(event: any, item: any, mappingSelectionValue: any) {
    event.target.parentNode.classList.toggle("active-selected");
    if (mappingSelectionValue === "accountDescriptioDisable") {
      this.storeItemKeys(item);
    }
    if (event.shiftKey) {
      let lastSelectedIndex;
      if (mappingSelectionValue === "accountDescriptioDisable") {
        lastSelectedIndex = this.accountDescriptionList.indexOf(item);
      } else {
        lastSelectedIndex = this.availableAccountDescriptions.indexOf(item);
      }

      let greaterIndex = 0;
      let tempindex: any;

      if (this.selectedMultipleAccountDescriptions.length > 0) {
        for (
          let i = 0;
          i < this.selectedMultipleAccountDescriptions.length;
          i++
        ) {
          if (mappingSelectionValue === "accountDescriptioDisable") {
            tempindex = this.accountDescriptionList.indexOf(
              this.selectedMultipleAccountDescriptions[i]
            );
          } else {
            tempindex = this.availableAccountDescriptions.indexOf(
              this.selectedMultipleAccountDescriptions[i]
            );
          }
          if (tempindex > greaterIndex && greaterIndex < lastSelectedIndex) {
            greaterIndex = tempindex;
          }
        }
      }

      for (let i = greaterIndex + 1; i <= lastSelectedIndex; i++) {
        if (mappingSelectionValue === "accountDescriptioDisable") {
          let element: any;
          if (
            this.selectedMultipleAccountDescriptions.indexOf(
              this.accountDescriptionList[i]
            ) === -1
          ) {
            this.selectedMultipleAccountDescriptions.push(
              this.accountDescriptionList[i]
            );
            // Checking SMId key in Account Description List
            if ("SMId" in this.accountDescriptionList[i]) {
              element = document.getElementById(
                this.accountDescriptionList[i].AccountDescription
              );
            } else {
              element = document.getElementById(
                this.accountDescriptionList[i].AccountDescription
              );
              this.storeItemKeys(this.accountDescriptionList[i]);
            }
            element.classList.remove("draggable-true");
            element.classList.add("draggable-true");
            element.classList.add("active-selected");
          }
        } else {
          if (
            this.selectedMultipleAccountDescriptions.indexOf(
              this.availableAccountDescriptions[i]
            ) === -1
          ) {
            this.selectedMultipleAccountDescriptions.push(
              this.availableAccountDescriptions[i]
            );
            const element = document.getElementById(
              this.availableAccountDescriptions[i].Id.toString()
            );
            element.classList.remove("draggable-true");
            element.classList.add("draggable-true");
            element.classList.add("active-selected");
          }
        }
      }
      if (lastSelectedIndex < greaterIndex) {
        if (mappingSelectionValue === "accountDescriptioDisable") {
          this.selectedMultipleAccountDescriptions.push(
            this.accountDescriptionList[lastSelectedIndex]
          );
        } else {
          this.selectedMultipleAccountDescriptions.push(
            this.availableAccountDescriptions[lastSelectedIndex]
          );
        }
      }
    } else {
      const index = this.selectedMultipleAccountDescriptions.indexOf(item);
      if (index > -1) {
        this.selectedMultipleAccountDescriptions.splice(index, 1);
      } else {
        this.selectedMultipleAccountDescriptions.push(item);
      }
    }
  }

  toggleAccordian(event) {
    const element = event.target;
    element.classList.toggle("active");
    const panel = element.parentNode.nextElementSibling;

    if (panel.classList.contains("hide")) {
      panel.classList.remove("hide");
      panel.classList.add("max-height-inherit");
    } else {
      panel.classList.remove("max-height-inherit");
      panel.classList.add("hide");
    }
  }

  toggleSort() {
    if (
      this.availableAccountDescriptions.filter((m) => m.NaturalAccount !== "")
        .length > 0
    ) {
      this.accountIdSortOrder = !this.accountIdSortOrder;
      return this.availableAccountDescriptions.sort((a, b) => {
        return this.accountIdSortOrder
          ? <any>b.NaturalAccountNumber - <any>a.NaturalAccountNumber
          : <any>a.NaturalAccountNumber - <any>b.NaturalAccountNumber;
      });
    }
  }
}
